import script from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ChartDataEditor.vue?vue&type=style&index=0&id=53b32689&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b32689"]])

export default __exports__